import React, {memo} from "react";
import { withStyles } from "@material-ui/core";
import { PhonelinkErase } from "@material-ui/icons";
import styles from "./styles";
import StyledToolTip from "../../../components/common/StyledToolTip";

class CancelDispatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
    };
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updateCancelDispatchStatus`,
      this.changeCancelDispatchStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updateCancelDispatchStatus`,
      this.changeCancelDispatchStatus
    );
  }

  changeCancelDispatchStatus = (enable) => {
    if (this.state.enable !== enable) {
      this.setState({
        enable,
      });
    }
  };

  onCancelDispatch = () => {
    if(this.state.enable){
        this.props.eventHub.emit("cancelDispatch");
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${
          this.state.enable ? classes.enabledDangerIcon : classes.disableIcon
        }`}
        onClick={this.onCancelDispatch}
      >
        <StyledToolTip title="Cancel Dispatch">
          <PhonelinkErase />
        </StyledToolTip>
      </div>
    );
  }
}

export default withStyles(styles)(memo(CancelDispatch));
